import { cloudinaryImage } from '../../lib/cloudinary';

export type Browser = 'chrome' | 'firefox' | 'edge';

interface BrowserInfo {
  name: string;
  fullName: string;
  storeUrl: string;
  icon: string;
  ratingUrl: string;
}

export const BROWSERS: Record<Browser, BrowserInfo> = {
  chrome: {
    name: 'Chrome',
    fullName: 'Chrome',
    storeUrl:
      'https://chromewebstore.google.com/detail/exify/llhmhhnpmiikplpnkmbgbgmlenleecle',
    icon: cloudinaryImage('w_20/chrome.png'),
    ratingUrl:
      'https://shields.io/chrome-web-store/rating/llhmhhnpmiikplpnkmbgbgmlenleecle.json',
  },
  firefox: {
    name: 'Firefox',
    fullName: 'Firefox',
    storeUrl: 'https://addons.mozilla.org/en-US/firefox/addon/exify/',
    icon: cloudinaryImage('w_20/firefox.png'),
    ratingUrl: 'https://shields.io/amo/rating/exify.json',
  },
  edge: {
    name: 'Edge',
    fullName: 'Microsoft Edge',
    storeUrl:
      'https://microsoftedge.microsoft.com/addons/detail/exify/jdccdgglhcfjfceflkbmggdokbaagclf',
    icon: cloudinaryImage('w_20/edge.png'),
    ratingUrl: '/api/stats/edge',
  },
};

export const BROWSER_LIST = Object.keys(BROWSERS) as Browser[];
